import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { modalTitleIconedStyles } from 'asterX-UI/Modals/modals.styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import {
  BASE_COLORS,
  ERROR_COLORS,
  INFO_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI/colors.constant'

const ModalTitleIconed = withStyles(modalTitleIconedStyles)(props => {
  const {
    children,
    classes,
    onClose,
    disableBtn = false,
    iconComponent,
    subtitle,
    variant,
    hasIcon,
    ...other
  } = props

  const getColor = () => {
    const [info, warning, error, success] = MODAL_STYLES.variant
    if (variant === info) {
      return INFO_COLORS[600]
    }
    if (variant === warning) {
      return WARNING_COLORS[400]
    }
    if (variant === error) {
      return ERROR_COLORS[600]
    }
    if (variant === success) {
      return SUCCESS_COLORS[600]
    }
    return BASE_COLORS.Black
  }
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div
        className={classes.iconContainer}
        style={{
          justifyContent: 'space-between'
        }}
      >
        {!!iconComponent ? (
          <div className={classes.icon}>
            {hasIcon ? iconComponent : ''}
            <div
              className={classes.title}
              style={{
                color: getColor()
              }}
            >
              {children}
            </div>
          </div>
        ) : (
          <div className={classes.icon}>
            <div
              className={classes.title}
              style={{
                color: getColor()
              }}
            >
              {children}
            </div>
          </div>
        )}

        {onClose
          ? !disableBtn && (
              <IconCloseButton
                aria-label="close"
                className={classes.closeButton}
                onClick={onClose}
              />
            )
          : null}
      </div>

      {!!subtitle && (
        <Typography variant={'body1'} color={'textSecondary'}>
          {subtitle}
        </Typography>
      )}
    </MuiDialogTitle>
  )
})
export default ModalTitleIconed
ModalTitleIconed.propTypes = {
  onClose: PropTypes.func,
  iconComponent: PropTypes.node,
  children: PropTypes.any,
  disableBtn: PropTypes.bool,
  subtitle: PropTypes.string
}
